import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';

import SelectItem from '../../../../../../components/form/selectitem';
import TextareaItem from '../../../../../../components/form/textareaitem';
import SwitchItem from '../../../../../../components/form/switchitem';

const { RangePicker } = DatePicker;
const types = [{ name: "Throttle", value: "throttle", disabled: false }, { name: "Downtime", value: "downtime", disabled: true }];

class DowntimeForm extends React.PureComponent {
  onChangeDowntime = event => {
    if (event.target.name) {
      this.props.onChange({ [event.target.name]: event.target.value });
    }
  }

  onChangeSwitch = (value, event) => {
    if (event.target.name)
      this.props.onChange({ [event.target.name]: value })
  }

  onChangeSelect = type => {
    this.props.onChange({ 'type': type });
  }

  onChangeDateRange = date => {
    this.props.onChange({ 'start': date[0], 'end': date[1] });
  }

  render() {
    const { downtime } = this.props;
    return (
      <div className="ori-pad-15">
        <SwitchItem switch_text_class="ori-l-pad-5 ori-font-default ori-font-xs" switch_text={downtime.active ? "Active" : "Inactive"} name="active" checked={downtime.active} onChange={this.onChangeSwitch} />
        <SelectItem title="type" placeholder="select type" value={downtime.type} options={types} name_key="name" value_key="value" onChange={this.onChangeSelect} is_option_object_type />
        <div className="ori-tb-pad-10">
          <p className="ori-b-mrgn-5">Set Time</p>
          <RangePicker className="ori-full-width ori-range-picker-default" showTime={{ format: 'HH:mm A' }} placeholder={['Start Time', 'End Time']} format="hh:mm A, DD MMM YYYY" value={[moment(downtime.start), moment(downtime.end)]} onChange={this.onChangeDateRange} />
        </div>
        <TextareaItem title="Reason" className="ori-border-radius-20 ori-font-md" minRows={2} maxRows={3} placeholder="write reason for this downtime" name="reason" value={downtime.reason} onChange={this.onChangeDowntime} />
      </div>
    );
  }
}

DowntimeForm.propTypes = {
  downtime: PropTypes.object,
  onChange: PropTypes.func,
};

DowntimeForm.defaultProps = {
  downtime: {},
};

export default DowntimeForm;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/settings/downtime/downtimeform/index.js